import { PersonalityType } from "./PersonalityType"

export interface QuestionData {
    question: string
    answers: Array<[string, PersonalityType]>
}

export const personalityQuizData: Array<QuestionData> = [
    {
        question: "If you had to pick one word to describe yourself, what would it be?",
        answers: [
            ["Daring", PersonalityType.RISK_TAKER],
            ["Quiet", PersonalityType.SHY],
            ["Athletic", PersonalityType.ATHLETIC],
            ["Fun", PersonalityType.EXTROVERT],
            ["Kind", PersonalityType.KIND_HELPFUL],
        ],
    },
    {
        question: "You would most likely be found…",
        answers: [
            ["In a large group of friends", PersonalityType.EXTROVERT],
            ["Helping a friend with their homework", PersonalityType.KIND_HELPFUL],
            ["Outside playing a sport", PersonalityType.ATHLETIC],
            ["Doing something different, maybe dangerous", PersonalityType.RISK_TAKER],
            ["Talking to one or two friends you know very well", PersonalityType.SHY],
        ],
    },
    {
        question: "Which of the following are you most likely to say to someone at a party?",
        answers: [
            ["I really like your shirt!", PersonalityType.EXTROVERT],
            ["Can I get you a soda?", PersonalityType.KIND_HELPFUL],
            ["Hi…..er….what’s your name?", PersonalityType.SHY],
            ["I love this song! Turn it up!", PersonalityType.RISK_TAKER],
            ["C’mon, let’s play Twister!", PersonalityType.ATHLETIC],
        ],
    },
    {
        question: "Your friends would most likely describe you as…",
        answers: [
            ["Different", PersonalityType.SHY],
            ["Active", PersonalityType.ATHLETIC],
            ["Nice to everyone", PersonalityType.KIND_HELPFUL],
            ["Exciting to be around", PersonalityType.RISK_TAKER],
            ["Popular", PersonalityType.EXTROVERT],
        ],
    },
    {
        question: "You are given $100! What would you be most likely to do with it?",
        answers: [
            ["Save it", PersonalityType.SHY],
            ["Get tickets for a game", PersonalityType.ATHLETIC],
            ["Go shopping with my friends", PersonalityType.EXTROVERT],
            ["Buy the first thing I see", PersonalityType.RISK_TAKER],
            ["Give some of it away", PersonalityType.KIND_HELPFUL],
        ],
    },
]